
export function filterNumericInput(event: KeyboardEvent) {
  const key = event.key
  if (key === 'Backspace') return
  if (key === 'Delete') return
  if (key >= '0' && key <= '9') return
  event.preventDefault()
}
